import { Select } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SelectProfile = styled(Select)(({theme}) => ({
  color: theme.select.main,
  '&:before': {
    borderColor: theme.select.main,
  },
  '&:after': {
    borderColor: theme.select.main,
  },
  '& .MuiSelect-icon': {
    fill: theme.select.main,
    color: theme.select.main,
  },
  '& .MuiTypography-root': {
    whiteSpace: 'normal'
  }
  
}));

export const SelectProfileUser = styled(Select)(() => ({
  backgroundColor: '#FFFFFF',
  color: '#000000'
}));
